import 'bootstrap/js/dist/modal';

document.addEventListener('DOMContentLoaded', () => {
    const modalBusca = document.getElementById('modal-busca');
    const modalBula = document.getElementById('modal-bula');

    if (modalBusca) {
        new bootstrap.Modal(modalBusca, { backdrop: false });
    }

    if (modalBula) {
        new bootstrap.Modal(modalBula, { backdrop: false });
    }

    document.querySelectorAll('.navegacao-dor .nav-link').forEach(navLink => {
        navLink.addEventListener('click', function () {
            const id_produto = this.id.replace('button-', '');

            console.log(id_produto);

            document.querySelectorAll('.navegacao-dor .nav-link').forEach(link => link.classList.remove('active'));
            document.querySelectorAll('.apresentacao-produto').forEach(produto => {
                produto.classList.remove('active');
                produto.setAttribute('aria-hidden', 'true');
            });

            document.getElementById(`button-${id_produto}`).classList.add('active');
            const produtoElement = document.getElementById(`produto-${id_produto}`);
            if (produtoElement) {
                produtoElement.classList.add('active');
                produtoElement.setAttribute('aria-hidden', 'false');
            }

            const escala = document.querySelector('.escala');
            if (escala) {
                if (id_produto === 'buscopan') {
                    escala.value = 1;
                } else if (id_produto === 'buscoduo') {
                    escala.value = 6;
                } else {
                    escala.value = 9;
                }
            }
        });
    });

    function alterarProduto(event) {
        const nivel_dor = event.target.textContent || event.target.value || event.target.dataset.nivelDor;

        const escala = document.querySelector('.escala');
        if (escala) {
            escala.value = nivel_dor;
        }

        document.querySelectorAll('.navegacao-dor .nav-link').forEach(link => link.classList.remove('active'));
        document.querySelectorAll('.apresentacao-produto').forEach(produto => {
            produto.classList.remove('active');
            produto.setAttribute('aria-hidden', 'true');
        });

        if (nivel_dor >= 1 && nivel_dor < 5) {
            const button = document.getElementById('button-buscopan');
            const produto = document.getElementById('produto-buscopan');
            if (button) button.classList.add('active');
            if (produto) {
                produto.classList.add('active');
                produto.setAttribute('aria-hidden', 'false');
            }
        } else if (nivel_dor >= 5 && nivel_dor <= 7) {
            const button = document.getElementById('button-buscoduo');
            const produto = document.getElementById('produto-buscoduo');
            if (button) button.classList.add('active');
            if (produto) {
                produto.classList.add('active');
                produto.setAttribute('aria-hidden', 'false');
            }
        } else if (nivel_dor > 7) {
            const button = document.getElementById('button-buscopan-composto');
            const produto = document.getElementById('produto-buscopan-composto');
            if (button) button.classList.add('active');
            if (produto) {
                produto.classList.add('active');
                produto.setAttribute('aria-hidden', 'false');
            }
        }
    }

    const escalaElement = document.querySelector('.escala');
    if (escalaElement) {
        escalaElement.addEventListener('change', alterarProduto);
    }

    document.querySelectorAll('#tickmarks .nivel-dor').forEach(nivelDor => {
        nivelDor.addEventListener('click', function (event) {
            event.preventDefault();
            const nivel_dor = event.target.textContent || event.target.value || event.target.dataset.nivelDor;

            const escala = document.querySelector('.escala');
            if (escala) {
                escala.value = nivel_dor;
            }

            let nivel_dor_atual = document.querySelector('.nivel-dor.active');
            if (nivel_dor_atual) {
                nivel_dor_atual.classList.remove('active');
            }
            this.classList.add('active');
        });
        nivelDor.addEventListener('click', alterarProduto);
    });
});